export const popupWindow = (
  url: string,
  external = false,
  width = 1024,
  height = 768,
): Window | null => {
  const left = Math.round(screen.width / 2 - width / 2); // Medida ventana ancho
  const top = Math.round(screen.height / 2 - height / 2); // Medida ventana alto
  const isWebview = sessionStorage.getItem('iswebview');
  if (isWebview && isWebview === 'true') {
    const finalUrl = ensureExternalParam(url);
    showWebviewDebugFlag();
    showDebugUrl(finalUrl);
    // Persist critical data to localStorage before cross-domain navigation (sessionStorage may be lost)
    persistCriticalDataForWebview();
    windowLocation(finalUrl);
    return null;
  } else {
    return window.open(
      url,
      'PoP_Up',
      `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, titlebar=no, resizable=no, copyhistory=no, width=${width}, height=${height}, top=${top}, left=${left}`,
    );
  }
};


const ensureExternalParam = (url: string): string => {
  if (/([?&])external=1([&#]|$)/.test(url)) {
    return url;
  }
  return `${url}${url.includes('?') ? '&' : '?'}external=1`;
};

const showWebviewDebugFlag = (): void => {
  const existingFlag = document.getElementById('iswebview-debug-flag');
  if (existingFlag) {
    existingFlag.textContent = 'iswebview=true';
    return;
  }

  const debugFlag = document.createElement('div');
  debugFlag.id = 'iswebview-debug-flag';
  debugFlag.textContent = 'iswebview=true';
  debugFlag.style.position = 'fixed';
  debugFlag.style.right = '8px';
  debugFlag.style.bottom = '72px';
  debugFlag.style.zIndex = '2147483647';
  debugFlag.style.padding = '4px 8px';
  debugFlag.style.background = '#005A5A';
  debugFlag.style.color = '#FFFFFF';
  debugFlag.style.fontSize = '12px';
  debugFlag.style.borderRadius = '4px';
  document.body.appendChild(debugFlag);
};

const showDebugUrl = (url: string): void => {
  const existingUrlDiv = document.getElementById('url-debug');
  if (existingUrlDiv) {
    existingUrlDiv.textContent = `url=${url}`;
    return;
  }

  const urlDiv = document.createElement('div');
  urlDiv.id = 'url-debug';
  urlDiv.textContent = `url=${url}`;
  urlDiv.style.position = 'fixed';
  urlDiv.style.right = '8px';
  urlDiv.style.bottom = '8px';
  urlDiv.style.zIndex = '2147483647';
  urlDiv.style.padding = '4px 8px';
  urlDiv.style.background = '#005A5A';
  urlDiv.style.color = '#FFFFFF';
  urlDiv.style.fontSize = '12px';
  urlDiv.style.borderRadius = '4px';
  document.body.appendChild(urlDiv);
};

export const _locationNav = {
  replace: (url: string): void => { (window.location as any).replace(url); }
};

export const windowLocation = (url: any): boolean => {
  var X = setTimeout(() => {
    _locationNav.replace(url);
    return true;
  }, 300);

  if (window.location === url) {
    clearTimeout(X);
    return true;
  } else {
    if ((window.location as any).href === url) {
      clearTimeout(X);
      return true;
    } else {
      clearTimeout(X);
      _locationNav.replace(url);
      return true;
    }
  }
};

export const openWindowWithPostRequest = (
  message: string,
  paramsAsBody = false,
): void => {
  const redirectUri = decodeURIComponent(
    sessionStorage.getItem('redirectUri') as string,
  );
  const token = sessionStorage.getItem('_dwtk') as string;
  const params: Array<{ name: string; value: string }> = JSON.parse(
    sessionStorage.getItem('params') as string,
  ).concat([
    { name: 'status', value: message },
    { name: 'canal', value: 'MOV' },
  ]);
  let index = 0;
  let parsedParams = params.reduce(
    (
      stringParams: string,
      { name, value }: { name: string; value: string },
    ) => {
      stringParams += `${name}=${encodeURI(value)}`; // Encode the parameter value
      if (index < params.length - 1) {
        stringParams += '&';
      }
      index++;
      return stringParams;
    },
    '?',
  );
  parsedParams += `&language=${encodeURI(sessionStorage.getItem('language') as string)}`; // Encode the language value
  const form = document.createElement('form');
  form.setAttribute('method', 'post');

  if (paramsAsBody) {
    form.setAttribute('action', encodeURI(redirectUri));
    params.push({ name: 'token', value: token });
    params.forEach((param: { name: string; value: string }) => {
      const mapInput = document.createElement('input');
      mapInput.name = param.name;
      mapInput.setAttribute('value', param.value);
      form.appendChild(mapInput);
    });
    document.body.appendChild(form);
    form.submit();
    return;
  }

  // If not params as body.
  form.setAttribute('action', encodeURI(redirectUri + parsedParams));
  const input = document.createElement('input');
  input.type = 'hidden';
  input.name = 'token';
  input.value = token;
  form.appendChild(input);
  document.body.appendChild(form);
  form.submit();
};

export const getCookie = (name: string): string | null => {
  let cookieValue = null;
  const value = '; ' + document.cookie;
  const parts = value.split('; ' + name + '=');
  if (parts.length === 2) {
    cookieValue = (parts.pop() || '').split(';').shift() || '';
  }
  return cookieValue;
};

export const deleteCookie = (name: string): void => {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

/**
 * Persist critical sessionStorage data to localStorage before navigating away in webview mode.
 * This prevents data loss when cross-domain navigation clears sessionStorage.
 */
export const persistCriticalDataForWebview = (): void => {
  const keysToBackup = [
    '_dwtk',
    'iswebview',
    'ASPSP',
    'prop-unique-id',
    'app-unique-id',
    'language',
    'operationChannel',
    'params',
  ];
  keysToBackup.forEach((key) => {
    const value = sessionStorage.getItem(key);
    if (value) {
      localStorage.setItem('__trusso_backup_' + key, value);
    }
  });
};

/**
 * Restore critical data from localStorage backup into sessionStorage.
 * Used in callback-login to recover data lost during cross-domain navigation in webview.
 */
export const restoreCriticalDataFromBackup = (): void => {
  const keysToRestore = [
    '_dwtk',
    'iswebview',
    'ASPSP',
    'prop-unique-id',
    'app-unique-id',
    'language',
    'operationChannel',
    'params',
  ];
  keysToRestore.forEach((key) => {
    const backupValue = localStorage.getItem('__trusso_backup_' + key);
    if (backupValue && !sessionStorage.getItem(key)) {
      sessionStorage.setItem(key, backupValue);
    }
  });
};

/**
 * Clean up localStorage backup after successful restore.
 */
export const clearCriticalDataBackup = (): void => {
  const keysToClean = [
    '_dwtk',
    'iswebview',
    'ASPSP',
    'prop-unique-id',
    'app-unique-id',
    'language',
    'operationChannel',
    'params',
  ];
  keysToClean.forEach((key) => {
    localStorage.removeItem('__trusso_backup_' + key);
  });
};
